import axios from 'axios';
import dayjs from 'dayjs';
import { FORMDATA_HEADER, JSON_HEADER } from './header.axios';
import TokenService from './token.axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { ...JSON_HEADER },
  withCredentials: true,
});

let isExpired = false;
instance.interceptors.request.use(
  (config) => {
    // check if access token is expired
    const user = TokenService.getUser();

    if (user?.date) {
      isExpired = dayjs(user.date).add(1, 'd').isBefore(dayjs());
    }
    if (config.data instanceof FormData) {
      // eslint-disable-next-line no-param-reassign
      config.headers = { ...FORMDATA_HEADER };
    }
    if (isExpired) {
      return Promise.reject(new Error('Access token expired.'));
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (res) => {
    isExpired = false;
    const { url } = res.config;
    if (url === '/users/login') {
      TokenService.setUser(res.data);
    }
    if (res.config.abortController) {
      // activeControllers.delete(response.config.url);
      delete res.config.abortController;
    }
    return res;
  },
  // eslint-disable-next-line consistent-return
  (err) => {
    if (
      (err?.response?.status === 401 && !isExpired) ||
      (err?.response?.status === 403 && !isExpired) ||
      err?.message === 'Access token expired.'
    ) {
      isExpired = true;

      TokenService.removeUser();
      window.location = '/login';
    } else return Promise.reject(err);
  }
);

export default instance;
